export const gridFullWidth = 12;
export const gridHalfWidth = 6;
